import React, {FC, MouseEvent, useState} from 'react';
import {useTranslation} from 'react-i18next';

import AgentSelectButton from 'components/AgentScreenComponents/_buttons/AgentSelectButton';
import {MdxEditorCustomButtonType} from 'components/MdxEditorField/helper';

import CustomButtonItemsSelectorPopover from 'components/CodeMirrorField/CustomButtonItemsSelectorPopover';

interface CustomButtonItemsSelectorType {
    button: MdxEditorCustomButtonType;
    hasSearchByCustomButtonOptions?: boolean;
    onOptionSelect: (value: string) => void;
}

const CustomButtonItemsSelector: FC<CustomButtonItemsSelectorType> = ({
    button,
    hasSearchByCustomButtonOptions,
    onOptionSelect,
}) => {
    const [t] = useTranslation();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const {title, items} = button;

    const open = Boolean(anchorEl);

    return (
        <>
            <AgentSelectButton title={t(title)} onClick={handleClick} open={open} />
            <CustomButtonItemsSelectorPopover
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                items={items}
                open={open}
                onOptionSelect={onOptionSelect}
                hasSearchByCustomButtonOptions={hasSearchByCustomButtonOptions}
            />
        </>
    );
};

export default CustomButtonItemsSelector;
